/* eslint-disable */
import {gsap} from "gsap";
import ScrollToPlugin from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollToPlugin);

window.addEventListener('load', () => {
  ServicesCTABlock.init();
});

const ServicesCTABlock = {
  init: function () {
    const sections = document.querySelectorAll('[data-services-cta-block-js]');

    if (!sections.length) return;

    sections.forEach((section) => {
      this.tabSwitching(section);
    })

    this.tabUrls();
  },

  tabSwitching: function (section) {
    let tabTriggers = section.querySelectorAll('[data-tab-trigger-js]');
    let tabs = section.querySelectorAll('[data-tab-js]');
    if (!tabTriggers && tabTriggers.length === 0 && !tabs && tabs.length === 0) return;

    tabTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        // if (trigger.classList.contains('is-active')) return;

        let activeTrigger = section.querySelector('[data-tab-trigger-js].is-active');
        let activeTab = section.querySelector('[data-tab-js].is-active');
        let triggerIndex = trigger.getAttribute('data-tab-trigger-js');
        let newActiveTab = section.querySelector(`[data-tab-js='${triggerIndex}']`);

        if (activeTrigger) {
          activeTrigger.classList.remove('is-active');
        }
        if (activeTab) {
          activeTab.classList.remove('is-active');
        }
        if (newActiveTab) {
          newActiveTab.classList.add('is-active');

          gsap.to(window, {
            scrollTo: {
              y: newActiveTab,
            },
            duration: 0.5,
            ease: "linear"
          });
        }

        trigger.classList.add('is-active');
      })
    })
  },

  tabUrls: function () {
    let urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('tab')) {
      let tabValue = urlParams.get('tab');
      let targetElement = document.querySelector(`[data-tab-trigger-js="${tabValue}"]`);
      if (targetElement) {
        targetElement.click();
      }
    }
  }

}

export default ServicesCTABlock;
